import { Button, Form, RefreshIcon, TextButton } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import styles from './SearchFilter.module.scss';

const SearchFilter = ({
  formId = 'search-filter-form',
  children,
  layout = 'grid',
  onSubmit,
  onReset,
}: {
  formId?: string;
  children: React.ReactNode;
  /** grid: 6열 균등 배치. flow: 필터가 각자 폭을 갖고 줄바꿈 */
  layout?: 'grid' | 'flow';
  onSubmit: () => void;
  onReset: () => void;
}) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <Form className={styles['search-filter-container']} onSubmit={handleSubmit} id={formId}>
      <div className={clsx(styles['filters-container'], styles[`layout-${layout}`])}>{children}</div>
      <div className={styles['actions-container']}>
        <Button className={styles['search-button']} size="small" type="submit" form={formId}>
          검색
        </Button>
        <TextButton
          className={styles['reset-button']}
          leftIcon={<RefreshIcon size={16} />}
          size="small"
          color="secondary"
          onClick={onReset}
        >
          필터 초기화
        </TextButton>
      </div>
    </Form>
  );
};

export default SearchFilter;
